/**
 * Default indirect verification = all profile HQ countries minus those with a dedicated
 * registry API in the server verification orchestrator (before KYB).
 *
 * Keep `ALL_PROFILE_HEADQUARTERS_COUNTRY_NAMES` in sync with `countriesData` in
 * `packages/web/src/components/shared/constants/general.const.ts`.
 */

/** HQ names excluded: Gridlines (IN), NZ/TW/UK/NO registries, EU members (VIES + EU_VAT UI). */
export const HEADQUARTERS_EXCLUDED_FROM_INDIRECT_VERIFICATION_DEFAULT: readonly string[] = [
  "India",
  "New Zealand",
  "Taiwan",
  "United Kingdom",
  "Norway",
  "Austria",
  "Belgium",
  "Bulgaria",
  "Croatia",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Estonia",
  "Finland",
  "France",
  "Germany",
  "Greece",
  "Hungary",
  "Ireland",
  "Italy",
  "Latvia",
  "Lithuania",
  "Luxembourg",
  "Malta",
  "Netherlands",
  "Poland",
  "Portugal",
  "Romania",
  "Slovakia",
  "Slovenia",
  "Spain",
  "Sweden",
];

/**
 * Every `name` from `countriesData.countryGroups` (HQ select values / `Company.headquartersCountry`).
 */
export const ALL_PROFILE_HEADQUARTERS_COUNTRY_NAMES: readonly string[] = [
  "Japan",
  "Thailand",
  "Taiwan",
  "Singapore",
  "India",
  "South Korea",
  "Sri Lanka",
  "Malaysia",
  "Indonesia",
  "Vietnam",
  "Philippines",
  "China (Mainland)",
  "China (Hong Kong)",
  "Bangladesh",
  "Nepal",
  "United Arab Emirates (UAE)",
  "Oman",
  "Kuwait",
  "Saudi Arabia",
  "Turkey",
  "Egypt",
  "Qatar",
  "Bahrain",
  "Israel",
  "Austria",
  "Belgium",
  "Bulgaria",
  "Croatia",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Estonia",
  "Finland",
  "France",
  "Germany",
  "Greece",
  "Hungary",
  "Ireland",
  "Italy",
  "Latvia",
  "Lithuania",
  "Luxembourg",
  "Malta",
  "Netherlands",
  "Norway",
  "Poland",
  "Portugal",
  "Romania",
  "Russia Federation",
  "Slovakia",
  "Slovenia",
  "Spain",
  "Sweden",
  "United Kingdom",
  "South Africa",
  "Kenya",
  "Morocco",
  "Australia",
  "New Zealand",
  "USA",
  "Canada",
  "Mexico",
  "Brazil",
];

export function getDefaultIndirectVerificationCountryNames(): string[] {
  const excluded = new Set(HEADQUARTERS_EXCLUDED_FROM_INDIRECT_VERIFICATION_DEFAULT);
  return ALL_PROFILE_HEADQUARTERS_COUNTRY_NAMES.filter((n) => !excluded.has(n));
}
